import { render, staticRenderFns } from "./NavigationHeader.vue?vue&type=template&id=05ca90ba&scoped=true&"
import script from "./NavigationHeader.vue?vue&type=script&lang=js&"
export * from "./NavigationHeader.vue?vue&type=script&lang=js&"
import style0 from "./NavigationHeader.vue?vue&type=style&index=0&id=05ca90ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ca90ba",
  null
  
)

export default component.exports